import _typeof from '@babel/runtime/helpers/typeof';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import { InputContainer } from './InputContainer.js';
import { InputInput } from './InputInput.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["className", "emailStyle", "endAdornment", "focusRef", "InputComponent", "lightStyle", "onClick", "startAdornment", "style", "success"];
var Input = /*#__PURE__*/React.forwardRef(function Input2(props, ref) {
  var className = props.className,
      _props$emailStyle = props.emailStyle,
      emailStyle = _props$emailStyle === void 0 ? false : _props$emailStyle,
      endAdornment = props.endAdornment,
      focusRef = props.focusRef,
      _props$InputComponent = props.InputComponent,
      InputComponent = _props$InputComponent === void 0 ? "input" : _props$InputComponent,
      _props$lightStyle = props.lightStyle,
      lightStyle = _props$lightStyle === void 0 ? false : _props$lightStyle,
      onClick = props.onClick,
      startAdornment = props.startAdornment,
      style = props.style,
      success = props.success,
      rest = _objectWithoutProperties(props, _excluded);

  var containerProps = {
    className: className,
    disabled: rest.disabled,
    emailStyle: emailStyle,
    endAdornment: endAdornment,
    error: rest.error,
    focusRef: focusRef,
    lightStyle: lightStyle,
    onClick: onClick,
    readOnly: rest.readOnly,
    startAdornment: startAdornment,
    style: style,
    success: success
  };
  return /*#__PURE__*/jsx(InputContainer, _objectSpread(_objectSpread({}, containerProps), {}, {
    children: /*#__PURE__*/jsx(InputInput, _objectSpread(_objectSpread({
      as: InputComponent
    }, rest), {}, {
      ref: ref
    }))
  }));
});
Input.propTypes = {
  "className": _PropTypes.string,
  "disabled": _PropTypes.bool,
  "emailStyle": _PropTypes.bool,
  "endAdornment": function checkAdornment(props, propName, componentName) {
    var isReactNodeType = function isReactNodeType(el) {
      var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for ? Symbol.for('react.element') : 0xeac7;
      var isValidElement = _typeof(el) === 'object' && el !== null && el['\$\$typeof'] === REACT_ELEMENT_TYPE;
      return el === undefined || el === null || typeof el === 'boolean' || typeof el === 'string' || isValidElement;
    };

    var adornment = (propName === 'startAdornment' || propName === 'endAdornment') && props[propName];

    if (!isReactNodeType(adornment)) {
      var name = adornment.displayName || adornment.name || 'Component';

      if (!(name.indexOf('Icon') === 0)) {
        return new Error("Invalid prop \"".concat(propName, "\". Invalid React component with name \"").concat(name, "\" was supplied to \"").concat(componentName, "\". Only Icon components are allowed.\n"));
      }
    }
  },
  "error": _PropTypes.bool,
  "focusRef": _PropTypes.shape({
    "current": _PropTypes.any.isRequired
  }),
  "InputComponent": _PropTypes.elementType,
  "lightStyle": _PropTypes.bool,
  "onClick": _PropTypes.func,
  "readOnly": _PropTypes.bool,
  "startAdornment": function checkAdornment(props, propName, componentName) {
    var isReactNodeType = function isReactNodeType(el) {
      var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for ? Symbol.for('react.element') : 0xeac7;
      var isValidElement = _typeof(el) === 'object' && el !== null && el['\$\$typeof'] === REACT_ELEMENT_TYPE;
      return el === undefined || el === null || typeof el === 'boolean' || typeof el === 'string' || isValidElement;
    };

    var adornment = (propName === 'startAdornment' || propName === 'endAdornment') && props[propName];

    if (!isReactNodeType(adornment)) {
      var name = adornment.displayName || adornment.name || 'Component';

      if (!(name.indexOf('Icon') === 0)) {
        return new Error("Invalid prop \"".concat(propName, "\". Invalid React component with name \"").concat(name, "\" was supplied to \"").concat(componentName, "\". Only Icon components are allowed.\n"));
      }
    }
  },
  "style": _PropTypes.object,
  "success": _PropTypes.bool
};
Input.displayName = "Input";

export { Input };
